module.exports = __webpack_public_path__ + "static/media/Playfair-Display.67c6fe4a.svg";